import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
  SuggestedAmountRadioButton,
  SuggestedAmountRadioButtonProps,
} from './SuggestedAmountRadioButton';
import styles from './DonationAmountSelector.scss';

type SuggestedAmountRadioGroupProps = {
  labelText: string;
  radioOptions: SuggestedAmountRadioButtonProps[];
};

export const SuggestedAmountRadioGroup: FunctionComponent<SuggestedAmountRadioGroupProps> = ({
  labelText,
  radioOptions,
}) => {
  return (
    <div
      className={classnames(
        'jg-form-group jg-space-mbsm',
        styles.amountSelectorGroup,
      )}
      role="group"
      aria-labelledby="donationAmountRadioGroupLabel"
    >
      <span id="donationAmountRadioGroupLabel" className="jg-sr-only">
        {labelText}
      </span>{' '}
      <ul className="jg-form-radio-btn__group jg-space-mbn">
        {radioOptions.map(({ id, labelText, checked, onChange }) => {
          return (
            <SuggestedAmountRadioButton
              key={id}
              id={id}
              labelText={labelText}
              checked={checked}
              onChange={onChange}
            />
          );
        })}
      </ul>
    </div>
  );
};
